import { useMemo } from 'react';

import { Currency } from '@/constants';
import { NETWORK as BTC_NETWORK } from '@/networks/btc-like/btc';
import { NetworkNet } from '@/networks/btc-like/common';
import { NETWORK as LTC_NETWORK } from '@/networks/btc-like/ltc';

const bnbExplorer = 'https://bscscan.com';
const ethExplorer = 'https://etherscan.io';
const btcExplorer = 'https://mempool.space';
const btcTestNetExplorer = 'https://mempool.space/testnet';
const tronExplorer = 'https://tronscan.org';
const ltcExplorer = 'https://litecoinspace.org';
const ltcTestNetExplorer = 'https://litecoinspace.org/testnet';
const polygonExplorer = 'https://polygonscan.com';
const dogeExplorer = 'https://dogechain.info';

function useExplorerByCurrency(currency: string) {
  return useMemo((): string => {
    switch (currency) {
      case Currency.CWEB:
        return (import.meta.env.VITE_EXPLORER_URL as string) || '';
      case Currency.BNB:
      case Currency.USDT_BNB:
      case Currency.USDC_BNB:
      case Currency.USD1_BNB:
      case Currency.WBTC_BNB:
        return bnbExplorer;
      case Currency.ETH:
      case Currency.USDT_ETH:
      case Currency.USDC_ETH:
      case Currency.USD1_ETH:
      case Currency.WBTC_ETH:
      case Currency.WCWEB_ETH:
        return ethExplorer;
      case Currency.BTC:
        return BTC_NETWORK.Network === NetworkNet.Mainnet ? btcExplorer : btcTestNetExplorer;
      case Currency.TRX:
      case Currency.USDT_TRX:
        return tronExplorer;
      case Currency.LTC:
        return LTC_NETWORK.Network === NetworkNet.Mainnet ? ltcExplorer : ltcTestNetExplorer;
      case Currency.POL:
        return polygonExplorer;
      case Currency.USDT_POL:
      case Currency.USDC_POL:
        return polygonExplorer;
      case Currency.DOGE:
        return dogeExplorer;
      default:
        return '';
    }
  }, [currency]);
}

export default useExplorerByCurrency;
